"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { ensureModalStyles } from "./modal_styles";
const TAB_LABEL_KEYS = {
  participation_multilingual: "participation",
  sentiment_over_time: "sentiment",
  agreement_disagreement: "argumentation",
  key_discussion_themes: "topics"
};
const DEFAULT_I18N = {
  title: "Analytics & Insights",
  loading: "Loading analytics...",
  error: "Failed to load analytics",
  empty: "No analytics data available.",
  image_unavailable: "Image unavailable.",
  method_notes: "Method notes",
  tabs: {
    participation: "Participation",
    topics: "Topics",
    sentiment: "Sentiment",
    argumentation: "Argumentation"
  }
};
export function analyticsI18n() {
  var _a;
  let parsed = {};
  try {
    parsed = JSON.parse(((_a = document.querySelector('meta[name="decidim-insights-analytics-i18n"]')) == null ? void 0 : _a.content) || "{}");
  } catch (e) {
    parsed = {};
  }
  return __spreadProps(__spreadValues(__spreadValues({}, DEFAULT_I18N), parsed), { tabs: __spreadValues(__spreadValues({}, DEFAULT_I18N.tabs), parsed.tabs || {}) });
}
export function createModal(title, initialMessage) {
  ensureModalStyles();
  const overlay = document.createElement("div");
  overlay.className = "analytics-modal-overlay";
  overlay.innerHTML = `
    <div class="analytics-modal">
      <div class="analytics-modal__header">
        <h2 class="analytics-modal__title">${escapeHtml(title)}</h2>
        <button class="analytics-modal__close" aria-label="Close">&times;</button>
      </div>
      <div class="analytics-modal__tabs"></div>
      <div class="analytics-modal__content">
        <p class="analytics-modal__message">${escapeHtml(initialMessage)}</p>
      </div>
    </div>
  `;
  overlay.querySelector(".analytics-modal__close").addEventListener("click", () => {
    overlay.remove();
  });
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) overlay.remove();
  });
  document.addEventListener("keydown", function handler(e) {
    if (e.key === "Escape" && document.body.contains(overlay)) {
      overlay.remove();
      document.removeEventListener("keydown", handler);
    }
  });
  return overlay;
}
export function showModal(modal) {
  document.body.appendChild(modal);
}
export function escapeHtml(str) {
  const div = document.createElement("div");
  div.textContent = str;
  return div.innerHTML;
}
export function renderAnalyticsTabs(modal, data) {
  const i18n = analyticsI18n();
  const tabsContainer = modal.querySelector(".analytics-modal__tabs");
  const contentContainer = modal.querySelector(".analytics-modal__content");
  const visualisations = Array.isArray(data.visualisations) ? data.visualisations : [];
  if (!visualisations.length) {
    contentContainer.innerHTML = `<p>${escapeHtml(i18n.empty)}</p>`;
    return;
  }
  tabsContainer.innerHTML = visualisations.map(
    (vis, i) => `<button class="analytics-tab${i === 0 ? " analytics-tab--active" : ""}" data-tab-id="${escapeHtml(String(vis.id))}">${escapeHtml(tabLabel(vis, i18n))}</button>`
  ).join("");
  contentContainer.innerHTML = visualisations.map((vis, i) => renderVisualisationPanel(vis, i, i18n)).join("") + renderMethodNotes(data.method_notes, i18n);
  contentContainer.querySelectorAll(".analytics-visualisation__image").forEach((img) => {
    img.addEventListener("error", () => {
      const fallback = document.createElement("p");
      fallback.className = "analytics-visualisation__unavailable";
      fallback.textContent = i18n.image_unavailable;
      img.replaceWith(fallback);
    });
  });
  tabsContainer.addEventListener("click", (e) => {
    const btn = e.target.closest(".analytics-tab");
    if (!btn) return;
    tabsContainer.querySelectorAll(".analytics-tab").forEach((t) => t.classList.remove("analytics-tab--active"));
    contentContainer.querySelectorAll(".analytics-tab-panel").forEach((p) => p.classList.remove("analytics-tab-panel--active"));
    btn.classList.add("analytics-tab--active");
    const panel = contentContainer.querySelector(`[data-panel-id="${btn.dataset.tabId}"]`);
    if (panel) panel.classList.add("analytics-tab-panel--active");
  });
}
function tabLabel(vis, i18n) {
  const key = TAB_LABEL_KEYS[vis.id];
  return key && i18n.tabs[key] || vis.title || String(vis.id);
}
function renderVisualisationPanel(vis, index, i18n) {
  const basename = imageBasename(vis.image_file);
  const image = basename ? `<img class="analytics-visualisation__image" src="/api/visualization_image/${encodeURIComponent(basename)}" alt="${escapeHtml(vis.title || "")}">` : `<p class="analytics-visualisation__unavailable">${escapeHtml(i18n.image_unavailable)}</p>`;
  return `
    <div class="analytics-tab-panel${index === 0 ? " analytics-tab-panel--active" : ""}" data-panel-id="${escapeHtml(String(vis.id))}">
      ${image}
      ${vis.description ? `<p class="analytics-visualisation__description">${escapeHtml(vis.description)}</p>` : ""}
    </div>`;
}
function imageBasename(imageFile) {
  const path = String(imageFile || "").split("?")[0].split("#")[0];
  const segments = path.split("/");
  return segments[segments.length - 1];
}
function renderMethodNotes(notes, i18n) {
  if (!Array.isArray(notes) || !notes.length) return "";
  return `
    <details class="analytics-method-notes">
      <summary>${escapeHtml(i18n.method_notes)}</summary>
      <ul>${notes.map((note) => `<li>${escapeHtml(String(note))}</li>`).join("")}</ul>
    </details>`;
}
